import actionConsts from '../../constants/actions';

const introductionData = (state = [], action = {}) => {
    let { payload } = action
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return payload.introduction.introductionData;

        default:
            return state;
    }
};

export default introductionData;


// WEBPACK FOOTER //
// /src/reducers/uiState/introductionData.js